export function isPollingResponse(response) {
  return response.status === 202 && response.data?.url;
}
